import { IAnnualReport, IFinStatements } from '@modeso/types__aumico-lib-annualreport-be';
import { AppropriationOfProfit } from './classes/AppropriationOfProfit';
import { CashFlow } from './classes/CashFlow';
import { ComplementaryReports } from './classes/ComplementaryReports';
import { Ems } from './classes/Ems';
import { Notes } from './classes/Notes';
import { Template } from './classes/Template';
export interface IAnnualReportSectionsVisitor {
    visit(annualReport: IAnnualReport, finStatements: IFinStatements[]): void;
    visitTemplate(template: Template, templateIndex: number): void;
    visitNotes(notes: Notes): void;
    visitAop(aop: AppropriationOfProfit): void;
    visitCashFlow(cashFlow: CashFlow): void;
    visitEms(ems: Ems): void;
    visitComplementaryReports(reports: ComplementaryReports): void;
}
